import _typeof from "@babel/runtime/helpers/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import "core-js/modules/es.function.name.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import uploadMindsetMeetingTranscript from 'utils/mindset/uploadMindsetMeetingTranscript';
import processMindsetMeetingTranscript from 'utils/mindset/processMindsetMeetingTranscript';
import { setAlert } from 'actions/alerts';
function useUploadMindsetMeetingTranscript() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return useMutation({
    mutationFn: function () {
      var _mutationFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(options) {
        var file, onUploaded, s3FilePath;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              file = options.file, onUploaded = options.onUploaded;
              _context.next = 1;
              return uploadMindsetMeetingTranscript({
                file: file
              });
            case 1:
              s3FilePath = _context.sent;
              onUploaded === null || onUploaded === void 0 || onUploaded();
              return _context.abrupt("return", processMindsetMeetingTranscript({
                s3FilePath: s3FilePath
              }));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function mutationFn(_x) {
        return _mutationFn.apply(this, arguments);
      }
      return mutationFn;
    }(),
    onError: function onError(error, _ref) {
      var _error$details, _error$details2;
      var file = _ref.file;
      if (_typeof(error.details) === 'object' && (_error$details = error.details) !== null && _error$details !== void 0 && _error$details.fileId && (_error$details2 = error.details) !== null && _error$details2 !== void 0 && _error$details2.speakers) {
        error.match_failed_options = error.details;
        return;
      }
      setAlert({
        title: t('alert_file_uploaded_error', {
          name: file.name
        }),
        message: error.formattedErrorMessage || error.message,
        duration: 6000
      });
    }
  });
}
export default useUploadMindsetMeetingTranscript;